import gql from "graphql-tag";

export const MY_LEAVE_GET_EXAMINERS_NAME = gql`
  query getExaminersName($contract: String, $product: String, $locale: String) {
    getExaminersName(contract: $contract, product: $product, locale: $locale)
  }
`;
